import axios from "./axios";

export async function createDepartment(payload) {
  return axios
    .post(`/departments`, { department: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateDepartment(payload) {
  return axios
    .put(`/departments/` + payload.id, { department: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchDepartments(controller) {
  return axios({ method: "get", url: "/departments", params: controller })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}
